<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
      id="kt_login"
    >
      <!-- Left Panel -->
      <aside class="login-aside cpx-aside">
        <!-- Glow blobs -->
        <div class="blob blob-top"></div>
        <div class="blob blob-bottom"></div>
        <!-- Grid overlay -->
        <div class="grid-overlay" aria-hidden="true"></div>
        <!-- Logo watermark -->
        <span class="cpx-watermark" aria-hidden="true"></span>

        <div class="aside-content">
          <!-- Logo -->
          <div class="aside-logo">
            <img src="media/logos/logo-main.png" alt="CPX" class="cpx-logo" />
          </div>

          <div class="aside-main">
            <!-- Badge -->
            <div class="aside-badge">
              <span class="badge-dot"></span>
              MENA's leading affiliate network
            </div>

            <!-- Heading -->
            <h1 class="aside-heading">
              Partner with the
              <span class="heading-line2">world's <em class="script-text">leading brands.</em></span>
            </h1>

            <p class="aside-subtitle">Join the CPX affiliate program and start earning today.</p>

            <ul class="aside-features">
              <li v-for="item in features" :key="item.title" class="feature-item">
                <span class="feature-check">
                  <svg viewBox="0 0 12 12" aria-hidden="true">
                    <path d="M2 6.3 4.6 9 10 3.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
                <div>
                  <p class="feature-title">{{ item.title }}</p>
                  <p class="feature-desc">{{ item.desc }}</p>
                </div>
              </li>
            </ul>
          </div>

          <p class="aside-footer-text">Earn from anywhere. Anytime.</p>
        </div>
      </aside>

      <!-- Right Panel -->
      <div class="flex-row-fluid d-flex flex-column position-relative overflow-scroll cpx-right">
        <div class="d-flex flex-column-fluid flex-center">
          <router-view></router-view>
        </div>
        <footer class="cpx-footer">
          <span>© 2026 CPX Affiliate</span>
          <a href="https://www.cpxaffiliate.com/en/terms" target="_blank">Terms</a>
          <a href="https://www.cpxaffiliate.com/en/privacy-policy" target="_blank">Privacy</a>
          <a href="https://www.cpxaffiliate.com/en/faq" target="_blank">Need help?</a>
        </footer>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
export default {
  name: "auth",
  data() {
    return {
      features: [
        {
          title: "Earn on every conversion",
          desc: "Commission for each order, sale, install or lead driven through your tracker."
        },
        {
          title: "Unlimited sharable trackers",
          desc: "Never time-sensitive — drop them on your blog, channel or social profile."
        },
        {
          title: "Monthly payouts, live stats",
          desc: "Bank transfers every month, with statistics and payout history on hand."
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@keyframes drift {
  0%   { transform: translate(0) scale(1); }
  100% { transform: translate(6%, -8%) scale(1.18); }
}
@keyframes drift-slow {
  0%   { transform: translate(0) scale(1); }
  100% { transform: translate(-6%, 8%) scale(1.18); }
}

/* ── Left panel ─────────────────────────────────────── */
.cpx-aside {
  position: relative;
  overflow: hidden;
  background-color: #ff5437;
  flex: 0 0 52%;
  max-width: 52%;
  display: flex;
  flex-direction: column;
  padding: 56px;

  @media (max-width: 991px) {
    flex: unset;
    max-width: unset;
    width: 100%;
    min-height: 320px;
    padding: 32px;
    display: none; /* hide on mobile like original */
  }
}

/* Blobs */
.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(130px);
  pointer-events: none;
}
.blob-top {
  top: -160px;
  left: -128px;
  width: 608px;
  height: 608px;
  background: rgba(255,255,255,0.12);
  animation: drift 22s ease-in-out infinite alternate;
}
.blob-bottom {
  right: -160px;
  bottom: -192px;
  width: 544px;
  height: 544px;
  background: rgba(255,255,255,0.08);
  animation: drift-slow 34s ease-in-out infinite alternate-reverse;
}

/* Grid overlay — black lines, 72px cells, subtle texture */
.grid-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(to right, rgba(0,0,0,0.08) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(0,0,0,0.08) 1px, transparent 1px) !important;
  background-size: 72px 72px !important;
  background-repeat: repeat !important;
}

/* Watermark: logo as background, 245% wide, left-anchored, rotated */
.cpx-watermark {
  position: absolute;
  right: -96px;
  bottom: -80px;
  width: 30rem;
  aspect-ratio: 400 / 445;
  background-image: url("/media/logos/logo-main.png");
  background-size: 245% auto;
  background-position: left center;
  background-repeat: no-repeat;
  pointer-events: none;
  opacity: 0.07;
  transform: rotate(-8deg);
}

/* Content */
.aside-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.cpx-logo {
  width: 8.25rem;
  height: auto;
  margin-bottom: auto; /* push rest down via aside-main flex */
}
.aside-main {
  margin-top: 8rem;
  max-width: 32rem;
}

/* Badge */
.aside-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(18,20,29,0.25);
  border-radius: 9999px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.14em;
  color: rgba(18,20,29,0.8);
  text-transform: uppercase;
  width: fit-content;
  margin-bottom: 28px;
}
.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #12141d;
  flex-shrink: 0;
}

/* Heading */
.aside-heading {
  font-size: 3.5rem;
  font-weight: 800;
  color: #12141d;
  line-height: 1.1;
  letter-spacing: -0.03em;
  margin-top: 0 !important;
  margin-bottom: 16px !important;
}
.heading-line2 {
  display: block;
  white-space: nowrap;
}
.script-text {
  font-family: 'Caveat', cursive;
  font-style: normal;
  font-weight: 700;
  font-size: 1.28em;
  letter-spacing: 0;
  vertical-align: baseline;
}

/* Subtitle */
.aside-subtitle {
  font-size: 16px;
  line-height: 1.75rem;
  color: rgba(18,20,29,0.75);
  margin-top: 0 !important;
  margin-bottom: 28px !important;
}

/* Feature list */
.aside-features {
  list-style: none !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column;
  gap: 20px;
}
.feature-item {
  display: flex;
  gap: 14px;
}
.feature-check {
  margin-top: 3px;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #12141d;
  color: #fff;
  display: grid;
  place-items: center;

  svg { width: 12px; height: 12px; }
}
.feature-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #12141d;
  margin-bottom: 4px;
  word-spacing: 3.125px;
}
.feature-desc {
  font-size: 16px;
  line-height: 1.6rem;
  color: rgba(18,20,29,0.72);
  margin: 0;
}

/* Footer text */
.aside-footer-text {
  font-size: 0.8rem;
  font-weight: 500;
  color: rgba(18,20,29,0.7);
  margin-top: 40px;
  margin-bottom: 0;
  position: relative;
  z-index: 2;
}

/* ── Right panel ─────────────────────────────────────── */
.cpx-right {
  padding: 40px 56px;
  @media (max-width: 991px) { padding: 24px; }
}

.cpx-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 20px;
  font-size: 0.78rem;
  color: #8e8d99;
  padding-top: 16px;

  a {
    color: #8e8d99;
    text-decoration: none;
    &:hover { color: #12141d; text-decoration: underline; }
  }
}
</style>
